import React from 'react';
import {makeStyles} from "@mui/styles";
import {Container} from "../ui/Container";
import { Card } from '@mui/material';
import {IntegrationCreateForm} from "./IntegrationCreateForm";

const useStyles = makeStyles(() => ({
    root: {
        padding: 24
    },
    cardRoot: {
        padding: 24,
        borderRadius: "16px !important" as any
    },
    formTitle: {
        fontSize: 18,
        lineHeight: "21px",
        fontWeight: 700,
        color: "#000",
        marginBottom: 16
    }
}));

export function IntegrationCreate() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Container>
                <Card className={classes.cardRoot}>
                    <h2 className={classes.formTitle}>Create Integration</h2>
                    <IntegrationCreateForm/>
                </Card>
            </Container>
        </div>
    );
}

